export const FontSize10 = "0.7142857142857143rem";
export const FontSize12 = "0.8571428571428571rem";
export const FontSize14 = "1rem";
export const FontSize16 = "1.1428571428571428rem";
export const FontSize18 = "1.2857142857142858rem";
export const FontSize20 = "1.4285714285714286rem";
export const FontSize24 = "1.7142857142857142rem";
export const FontSize28 = "2rem";
export const FontSize32 = "2.2857142857142856rem";
export const FontSize40 = "2.857142857142857rem";
export const FontSize48 = "3.4285714285714284rem";
export const FontSize56 = "4rem";
export const FontSize64 = "4.571428571428571rem";
export const FontSize80 = "5.714285714285714rem";
export const FontSize96 = "6.857142857142857rem";
